<template>
  <admin-header></admin-header>
  <admin-sidebar></admin-sidebar>
  <div class="page-wrapper">
    <div class="content me-4 pb-0">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <div class="my-auto mb-2">
          <h2 class="mb-1">Settings</h2>
          <nav>
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link to="/admin-template/index">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Settings</li>
            </ol>
          </nav>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="row">
        <div class="col-xl-3">
          <!-- inner sidebar -->
          <adminsettings-sidebar></adminsettings-sidebar>
          <!-- /inner sidebar -->
        </div>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-header">
              <h5>Website Settings</h5>
            </div>
            <form action="#">
              <div class="card-body pb-0">
                <div class="localization-content mb-3">
                  <div>
                    <h6 class="mb-3">Localization</h6>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Time Zone <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSel"
                          id="localsel"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Start Week On <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelOne"
                          id="localselone"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Date Format <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelTwo"
                          id="localseltwo"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Time Format <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelThree"
                          id="localselthree"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Default Language <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelFour"
                          id="localselfour"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Language Switcher <span class="text-danger">*</span>
                      </p>
                      <div>
                        <div class="form-check form-check-md form-switch">
                          <input
                            class="form-check-input form-label"
                            type="checkbox"
                            role="switch"
                            checked
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="localization-content border-0">
                  <div>
                    <h6 class="mb-3">Currency Information</h6>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Currency <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelFive"
                          id="localselfive"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Currency Symbol <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelSix"
                          id="localselsix"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Currency Position <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelSeven"
                          id="localselseven"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Decimal Seperator <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelEight"
                          id="localseleig"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div class="localization-list">
                      <p class="text-gray-9 fw-medium">
                        Thousand Seperator <span class="text-danger">*</span>
                      </p>
                      <div>
                        <vue-select
                          :options="LocalSelEightOne"
                          id="localseleigone"
                          placeholder="Select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center justify-content-end">
                  <a href="javascript:void(0);" class="btn btn-light me-2">Cancel</a>
                  <button type="submit" class="btn btn-primary">Save Changes</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between bg-white p-3">
      <p class="mb-0">
        <a href="javascript:void(0);">Privacy Policy</a>
        <a href="javascript:void(0);" class="ms-4">Terms of Use</a>
      </p>
      <p>
        &copy; 2025 Dreamsrent, Made with <span class="text-danger">❤</span> by
        <a href="javascript:void(0);" class="text-secondary">Dreams</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      LocalSel: ["Select", "(+5:30) GMT", "(+11:30) INR"],
      LocalSelOne: ["Select", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      LocalSelTwo: ["Select", "01 Jan 2025", "Jan 02 2025", "2025 Jan 02", "2025 02 Jan"],
      LocalSelThree: ["Select", "12 hrs", "24 hrs"],
      LocalSelFour: ["Select", "English", "French", "Gremany"],
      LocalSelFive: ["Select", "USD", "EURO"],
      LocalSelSix: ["Select", "$", "€"],
      LocalSelSeven: ["Select", "100$", "$100"],
      LocalSelEight: ["Select", ".", ","],
      LocalSelEightOne: ["Select", ".", ","],
    };
  },
};
</script>
